import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage.edit');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage-edit',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage.edit/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMypageEditComponent implements OnInit {
    public isSavingProfile: boolean = false;
    public profileErrorMessage: string = '';

    public conditionOptions: any[] = [
        { id: 'diabetes', label: '당뇨' },
        { id: 'hypertension', label: '고혈압' },
        { id: 'hyperlipidemia', label: '고지혈증' },
        { id: 'heart', label: '심장질환' },
        { id: 'arthritis', label: '관절염' },
        { id: 'none', label: '해당없음' }
    ];

    public constitutionOptions: any[] = [
        { id: 'taeyang', label: '태양인', desc: '활동적이고 상체가 발달' },
        { id: 'taeeum', label: '태음인', desc: '체격이 크고 소화력이 강함' },
        { id: 'soyang', label: '소양인', desc: '민첩하고 열이 많은 편' },
        { id: 'soeum', label: '소음인', desc: '체구가 작고 소화가 약한 편' },
        { id: 'unknown', label: '잘 모르겠어요', desc: 'AI가 분석해드립니다' }
    ];

    public profile: any = {
        name: '',
        email: '',
        role: 'user',
        age: '',
        gender: '',
        constitution: 'unknown',
        height: '',
        weight: '',
        conditions: []
    };

    public profileForm: any = {
        name: '',
        age: '',
        gender: '',
        constitution: 'unknown',
        height: '',
        weight: '',
        conditions: []
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadProfile();
        await this.service.render();
    }

    public async loadProfile() {
        let res = await wiz.call("profile");
        if (res.code === 200 && res.data) {
            const data = res.data.data || res.data;
            this.profile = { ...this.profile, ...data };
            this.syncProfileForm();
        }
    }

    private syncProfileForm() {
        this.profileForm = {
            name: this.profile.name || '',
            age: this.profile.age || '',
            gender: this.profile.gender || '',
            constitution: this.profile.constitution || 'unknown',
            height: this.profile.height || '',
            weight: this.profile.weight || '',
            conditions: Array.isArray(this.profile.conditions) ? [...this.profile.conditions] : []
        };
    }

    public goBack() {
        this.service.href('/mypage');
    }

    public async toggleCondition(id: string) {
        if (Array.isArray(this.profileForm.conditions) === false) {
            this.profileForm.conditions = [];
        }

        if (id === 'none') {
            this.profileForm.conditions = this.hasCondition('none') ? [] : ['none'];
        } else {
            this.profileForm.conditions = this.profileForm.conditions.filter((condition: string) => condition !== 'none');
            const index = this.profileForm.conditions.indexOf(id);
            if (index > -1) {
                this.profileForm.conditions.splice(index, 1);
            } else {
                this.profileForm.conditions.push(id);
            }
        }

        await this.service.render();
    }

    public async setGender(id: string) {
        this.profileForm.gender = id;
        await this.service.render();
    }

    public async setConstitution(id: string) {
        this.profileForm.constitution = id;
        await this.service.render();
    }

    public hasCondition(id: string): boolean {
        return Array.isArray(this.profileForm.conditions) && this.profileForm.conditions.includes(id);
    }

    public getBmiPreview(): string {
        const height = Number(this.profileForm.height);
        const weight = Number(this.profileForm.weight);

        if (!height || !weight) {
            return '-';
        }

        return (weight / ((height / 100) * (height / 100))).toFixed(1);
    }

    public async saveProfile() {
        if (this.isSavingProfile) {
            return;
        }

        this.isSavingProfile = true;
        this.profileErrorMessage = '';
        await this.service.render();

        let res = await wiz.call('update_profile', {
            name: this.profileForm.name || '',
            age: this.profileForm.age || '',
            gender: this.profileForm.gender || '',
            height: this.profileForm.height || '',
            weight: this.profileForm.weight || '',
            conditions: JSON.stringify(this.profileForm.conditions || []),
            constitution: this.profileForm.constitution || 'unknown'
        });

        this.isSavingProfile = false;

        if (res.code === 200) {
            this.service.href('/mypage?profile=updated');
            return;
        }

        this.profileErrorMessage = res.message || res.data?.message || '개인정보 저장 중 오류가 발생했습니다.';
        await this.service.render();
    }
}

export default PageMypageEditComponent;